import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { CertificateListItemResponse, SingleCertificateMetadata } from '../types';
import { apiRequest } from './utils/apiClient';

export const certificatesApi = {
  getUserCertificates: async (
    username: string,
    callback: (res: CertificateListItemResponse[]) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/certificates/v0/certificates/${username}/`;

    try {
      const data = await apiRequest<CertificateListItemResponse[]>({
        url,
        isAuth: true,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError('Error fetching user certificates', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },

  getCertificateMetadata: async (
    uuid: string,
    callback: (res: SingleCertificateMetadata) => void,
    errorCallback: (error: unknown) => void,
  ) => {
    const url = `${getConfig().LMS_BASE_URL}/api/certificates/${uuid}/`;

    try {
      const data = await apiRequest<SingleCertificateMetadata>({
        url,
        isAuth: false,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError(error);
      if (errorCallback) {
        errorCallback(error);
      }
    }
  },
};
